/*=========================================================================================
  File Name: moduleDepartmentState.js
  Description: Department Module State
==========================================================================================*/

export default {
	departments: [],
	totalDepartments: 0,
	showDepartmentCategorySidebar: false
};
